import React from "react";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import styles from "./recommended-products.module.css";
import { formatCurrency } from "@commons-monorepo/index";
import { RecommendedProduct } from "~/common/props/orchestrator";
import { getEnvVar } from "@commons-monorepo/index";
import UiCarousel from "~/components/ui-carousel/ui-carousel";
import { useOutletContext } from "@remix-run/react";

interface RecommendedProductsProps {
  className?: string;
}

const RecommendedProducts: FC<RecommendedProductsProps> = ({ className }) => {
  const { t } = useTranslation();
  const { isMobile } = useOutletContext<any>();
  const storeIsPrime = false;
  const partnerCountry = {};
  const recommenderProducts: any[] = [];
  const domain = getEnvVar("PUBLIC_HOST");

  return !storeIsPrime && !!recommenderProducts?.length ?
  <div className={`${styles.recommendedProductsWrapper} ${className}`}>
      <div className={styles.boxHeader}>
        <span className={styles.headerBadge}>{t("ads.ad")}</span>
        <h6 className={styles.headerTitle}>{t("ads.recommended_title")}</h6>
      </div>
      <UiCarousel
      classNameContent={styles.content}
      hideDots
      withArrows={!isMobile}>

        {recommenderProducts.map((item: RecommendedProduct) =>
      <a href={`${domain}/catalogo/${item.ownerId}`}>
            <div
          className={styles.productItem}
          key={`recommended-products-item-${item.productId}`}>

              <img src={item.image} className={styles.image} />
              <div className={styles.info}>
                <p className={styles.storeName}>{item.name}</p>
                <p className={styles.price}>
                  {formatCurrency(item.unitPrice, partnerCountry)}
                </p>
              </div>
            </div>
          </a>
      )}
      </UiCarousel>
    </div> :
  null;
};
export default RecommendedProducts;